module.exports = __webpack_public_path__ + "static/media/focusAreasIcon.c6d89f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/focusAreasIcon.png
// module id = 282
// module chunks = 0